// extracted by mini-css-extract-plugin
module.exports = {"commentFormPlaceholder":"kIzPB","commentBar":"_2PW8p","commentFormWrapper":"_33NCS","commentForm":"vD5r2"};